import { useEffect, useState } from 'react';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import RoundBlueButton from '@/components/profile/roundBlueButton'
import { listOfSections } from "@/pages/profile/sections/idVerification/constants"
import ImageEditer2 from '@/components/common/imageHandler/imageEditer2'
import { useSelector } from 'react-redux';
import { RootState } from '@/store/index';

import '@/pages/profile/sections/common.css'

export default function MarksheetDegreeCrop(props: any) {
    const { profile, common } = useLocalTranslation();
    const [image, setImage] = useState("")
    const [croppedImgDatUrl, setCroppedImgDatUrl] = useState("")
    const profileDetails = useSelector((state: RootState) => state.profileReducer.profile);
    const [errMsg, setErrMsg] = useState("")

    useEffect(() => {
        if (props.value) {
            setImage(props.value)
        }
    }, [props.value])



    const handleCrop = (imgDataUrl: any) => {
        setCroppedImgDatUrl(imgDataUrl)
    }

    const handleSubmit_ = () => {
        setErrMsg("")
        let croppedImgDatUrl_ = ""
        if (croppedImgDatUrl) {
            croppedImgDatUrl_ = croppedImgDatUrl
        } else {
            if (profileDetails.marksheetOrDegreeCert) {
                croppedImgDatUrl_ = profileDetails.marksheetOrDegreeCert
            }
        }

        if (croppedImgDatUrl_ !== "") {
            props.handleSubmit(croppedImgDatUrl, listOfSections.marksheetOrDegreeCertCrop)
        } else {
            setErrMsg(common.statusText.issueInUpdating)
        }

    }

    return (
        <div className='profileSectionOfSectionCommonMainCon'>

            <p className='commonH6'>
                {profile.identityVerificationSection.notes.n1}
                <b>{profile.identityVerificationSection.notes.n2}</b>
                {profile.identityVerificationSection.notes.n3}
            </p>

            {errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }

            {image &&
                <div className='proofImgCon'>
                    <ImageEditer2
                        ogImage={image}
                        maxWidth={400}
                        maxHeight={600}
                        loaderWidth={400}
                        loaderHeight={600}
                        handleCrop={handleCrop}
                    />
                </div>
            }


            <div className='commonBtnCon1'>
                <RoundBlueButton
                    disabled={props.isSubmitBtnLoading}
                    onClick={handleSubmit_}
                />
            </div>
        </div>
    );
}
